module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_d4/main_sp_511b79f64c4ec526aa0c3333a4fc92ba.jpg";